import { Text } from '../../primitives/Text';
import { cn } from '../../utils/cn';
import type { LegalConsentLineProps } from './LegalConsentLine.types';

/**
 * The one-line legal notice under a consent-bearing action — "By continuing,
 * you agree to our Terms of Service and Privacy Policy" at the foot of the
 * sign-in card, on web and mobile.
 *
 * Figma Caption S (12 medium secondary-400, centred) — the treatment the
 * age-gate consent line already uses. The sentence arrives pre-translated,
 * normally as a `<Trans>` whose anchors are `LegalConsentLink`s, so the two
 * platforms cannot drift on the wording OR on whether the policies are
 * tappable — the age-gate line shipped as a real link on web and as plain
 * text on mobile, which is exactly the drift this block exists to close.
 */
export function LegalConsentLine({ children, className, testID }: LegalConsentLineProps) {
  return (
    <Text
      as="p"
      className={cn(
        'text-center text-xs font-medium text-secondary-400 native:font-mona-medium',
        className,
      )}
      testID={testID}>
      {children}
    </Text>
  );
}
(LegalConsentLine as { displayName?: string }).displayName = 'LegalConsentLine';
